module.exports = __webpack_public_path__ + "static/media/sup.20184b4a.gif";